import actionTypes from "./actionTypes";

export const fetchInitializeAction = data => {
  return {
    type: actionTypes.FETCH_INITIALIZE,
    payload: data
  };
};

export const fetchInitializeFailedAction = err => {
  return {
    type: actionTypes.FETCH_INITIALIZE_FAILED,
    payload: err
  };
};

export const fetchInitializeSuccessAction = data => {
  return {
    type: actionTypes.FETCH_INITIALIZE_SUCCESS,
    payload: data
  };
};

export const loadStateFieldsAction = state => {
  return {
    type: actionTypes.LOAD_STATE_FIELDS,
    payload: state
  };
};

export const selectDropdownStateAction = value => {
  return {
    type: actionTypes.SELECT_DROPDOWN_STATE,
    payload: value
  };
};

export const setCurrentStateAction = state => {
  return {
    type: actionTypes.SET_CURRENT_STATE,
    payload: state
  };
};

export const resetCurrentStateAction = () => {
  return {
    type: actionTypes.RESET_CURRENT_STATE
  };
};

export const setFormFieldsAction = fields => {
  return {
    type: actionTypes.SET_FORM_FIELDS,
    payload: fields
  };
};

export const setColumnActive = (column, isActive) => ({
  type: actionTypes.SET_COLUMN_ACTIVE,
  payload: { column, isActive }
});

export const setColumnVisible = (column, visible) => ({
  type: actionTypes.SET_COLUMN_VISIBLE,
  payload: { column, visible }
});

export const setColumnOrder = (column, fromIndex, toIndex, workList) => ({
  type: actionTypes.SET_COLUMN_ORDER,
  payload: { column, fromIndex, toIndex, workList }
});


export const cloneWorkItemAction = (workitemId) => ({
  type: actionTypes.CLONE_WORKITEM,
  workitemId
});

export const enterDataManually = enter => {
    return {
        type: actionTypes.ENTER_DATA_MANUALLY,
        payload: enter
    };
};
